//日期格式互转
const date = (val,type) => {
  let date = new Date(val)
  if (Object.prototype.toString.call(date) == '[object Date]') {
    if (type == 'date') {
      let y = 1900 + date.getYear()
      let m = "0" + (date.getMonth() + 1)
      let d = "0" + date.getDate()
      return `${y}${m.substring(m.length - 2,m.length)}${d.substring(d.length - 2,d.length)}`
    }

    if (type == 'date2') {
      let y = 1900 + date.getYear()
      let m = "0" + (date.getMonth() + 1)
      let d = "0" + date.getDate()
      return `${y}-${m.substring(m.length - 2,m.length)}-${d.substring(d.length - 2,d.length)}`
    }

    if (type == 'datetime') {
      let y = 1900 + date.getYear()
      let m = "0" + (date.getMonth() + 1)
      let d = "0" + date.getDate()
      var h = "0" + date.getHours()
      var f = "0" + date.getMinutes()
      return `${y}-${m.substring(m.length - 2,m.length)}-${d.substring(d.length - 2,d.length)} ${h.substring(h.length - 2,h.length)}:${f.substring(f.length - 2,f.length)}:00`
    }
  } else {
    return ''
  }

}

export default {
  date
}



// WEBPACK FOOTER //
// ./src/libs/format.js